import ConnectedSubscriptionsModule from './ConnectedSubscriptionsModule';

export default ConnectedSubscriptionsModule;
